export default "__VITE_ASSET__5e3dc277__"